// src/components/AgregarTareaModal.js
import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import Disenio from '../Tareas/Disenio';
import Evento from '../Tareas/Evento';
import Impresion from '../Tareas/Impresion';
import PublicacionEnRedes from '../Tareas/PublicacionEnRedes';
import RevisionTexto from '../Tareas/RevisionTexto';
import SolicitudDePresupuesto from '../Tareas/SolicitudDePresupuesto';

const AgregarTareaModal = ({ show, handleClose, pedidoId}) => {
  const [valorDelSelect, setValorDelSelect] = useState('');

  const cambioSelect = (event) => {
    setValorDelSelect(event.target.value);
  };



  return (
    <Modal show={show} onHide={handleClose} >
      <Modal.Header closeButton>
        <Modal.Title>Agregar Tarea</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="formTaskType" className="mb-3">
            <Form.Label>Tipo de Tarea</Form.Label>
            <Form.Control as="select" value={valorDelSelect} onChange={cambioSelect}>
              <option value="">Selecciona una opción</option>
              <option value="Disenio">Diseño</option>
              <option value="Evento">Evento</option>
              <option value="Impresion">Impresión</option>
              <option value="PublicacionEnRedes">Publicación en redes</option>
              <option value="RevisionTexto">Revisión de texto</option>
              <option value="SolicitudProsupuesto">Solicitud de presupuesto</option>
            </Form.Control>
          </Form.Group>

          <div className="mb-4">
            {valorDelSelect === 'Disenio' && <Disenio idPedido={pedidoId} />}
            {valorDelSelect === 'Evento' && <Evento idPedido={pedidoId} />}
            {valorDelSelect === 'Impresion' && <Impresion idPedido={pedidoId}/>}
            {valorDelSelect === 'PublicacionEnRedes' && <PublicacionEnRedes idPedido={pedidoId}/>}
            {valorDelSelect === 'RevisionTexto' && <RevisionTexto idPedido={pedidoId}/>}
            {valorDelSelect === 'SolicitudProsupuesto' && <SolicitudDePresupuesto idPedido={pedidoId}/>}
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AgregarTareaModal;
